import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function Hero() {
  const scrollToAbout = () => {
    const el = document.getElementById('about');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-57">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/288tHxhpqXNwz7twcGjVJJ/hero-grass.jpg")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-58" />

      {/* Strong Dark Gradient Overlay */}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/70 via-black/50 to-black/70" data-id="element-59" />

      {/* Content */}
      <div className="relative z-20 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20" data-id="element-60">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col items-center" data-id="element-61">
          <motion.img variants={itemVariants} src="https://cdn.magicpatterns.com/uploads/nvcxggdRAb1MpybQfVMZFq/camp-badge.png" alt="Camp ALKEBULAN Badge" className="w-[150px] md:w-[200px] h-auto mb-8 drop-shadow-2xl" data-id="element-62" />

          <motion.p variants={itemVariants} className="text-gold text-sm md:text-base uppercase tracking-[0.2em] font-bold mb-4" data-id="element-63">
            Summer 2026 &middot; Registration Open
          </motion.p>

          <motion.h1 variants={itemVariants} className="font-heading text-white text-5xl md:text-7xl lg:text-8xl font-bold mb-2 drop-shadow-lg" data-id="element-64">
            Camp ALKEBULAN
          </motion.h1>

          <motion.h2 variants={itemVariants} className="font-heading text-gold text-2xl md:text-3xl lg:text-4xl italic mb-8 drop-shadow-md" data-id="element-65">
            Rooted in Purpose
          </motion.h2>

          <motion.p variants={itemVariants} className="text-cream/90 text-lg md:text-xl max-w-2xl mx-auto mb-6 leading-relaxed" data-id="element-66">
            A two-week transformative summer experience rooted in African
            culture, purpose, and community at Beulah Land Farms.
          </motion.p>

          <motion.p variants={itemVariants} className="text-gold font-bold text-lg md:text-xl mb-10" data-id="element-67">
            June 20 &ndash; July 5, 2026
          </motion.p>

          <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full sm:w-auto" data-id="element-68">
            <button onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full sm:w-auto bg-gold text-brown font-bold px-8 py-4 rounded-full hover:scale-105 hover:brightness-110 transition-all duration-300 shadow-lg" data-id="element-69">
              Pre-register Today
            </button>
            <button onClick={scrollToAbout} className="w-full sm:w-auto bg-transparent border-2 border-cream/50 text-cream font-bold px-8 py-4 rounded-full hover:bg-white/10 hover:border-cream transition-all duration-300" data-id="element-70">
              Learn More
            </button>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 cursor-pointer" onClick={scrollToAbout} data-id="element-71">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-72">
          <ChevronDownIcon className="text-cream/70 w-8 h-8" data-id="element-73" />
        </motion.div>
      </motion.div>
    </section>;
}